import React, { Component } from 'react'
import { Route, IndexRoute } from 'react-router'
import { bindActionCreators } from 'redux'
import App from './components/App/App'
import Login from './containers/Login/Login'
import Search from './containers/Search/Search'
import UploadCSV from './containers/UploadCSV/UploadCSV'
import Dashboard from './containers/Dashboard/Dashboard'
import TbuDashboard from './containers/TbuDashboard/TbuDashboard'
import EntityList from './containers/EntityList/EntityList'
import OrderDetails from './containers/OrderDetails/OrderDetails'
import InvoiceMonth from './containers/InvoiceMonth/InvoiceMonth'
import DropOpportunity from './containers/DropOpportunity/DropOpportunity'
import UnauthorisedAccess from './containers/UnauthorisedAccess/UnauthorisedAccess'
import TransferWallet from './containers/TransferWallet/TransferWallet'
import { getUser } from './actions/login'
import UserManagement from './containers/UserManagement'

const routeConfig = [
  {
    path: '/search',
    component: Search
  },
  {
    path: '/uploadcsv',
    component: UploadCSV
  },
  {
    path: '/tbu-dashboard',
    component: TbuDashboard
  },
  {
    path: '/invoice-month',
    component: InvoiceMonth
  },
  {
    path: '/drop-opportunity',
    component: DropOpportunity
  },
  {
    path: '/broker-dashboard',
    component: Dashboard,
    params: {
      dashboardType: 'BROKER'
    }
  },
  {
    path: '/developer-dashboard',
    component: Dashboard,
    params: {
      dashboardType: 'DEVELOPER'
    }
  },
  {
    path: '/makaan-dashboard',
    component: Dashboard,
    params: {
      dashboardType: 'MAKAAN'
    }
  },
  {
    path: '/owner-dashboard',
    component: Dashboard,
    params: {
      dashboardType: 'OWNER'
    }
  },
  {
    path: '/list/:dashboardType/:keyName',
    component: EntityList
  },
  {
    path: '/detail/:orderId',
    component: OrderDetails
  },
  {
    path: '/unauthorised-access',
    component: UnauthorisedAccess
  },
  {
    path: '/user-management',
    component: UserManagement
  },
  {
    path: '/transfer-wallet',
    component: TransferWallet
  }
]

export default store => (
  <Route path='/' component={App}>
    <IndexRoute component={Login} />
    {routeConfig.map(route => AuthRoute({ ...route, store }))}
  </Route>
)

function AuthRoute({ store, params = {}, ...props }) {
  return (
    <Route
      key={props.path}
      {...props}
      {...params}
      onEnter={(route, replace, cb) =>
        onEnterHandler(route, replace, cb, store)
      }
    />
  )
}

function onEnterHandler(route, replace, cb, store) {
  const getUserCall = bindActionCreators(getUser, store.dispatch)

  const state = store.getState()
  if (state.userInfo) {
    roleBaseNavigation(route, replace, cb, state)
  } else {
    getUserCall()
      .then(() => {
        const state = store.getState()
        roleBaseNavigation(route, replace, cb, state)
      })
      .catch(() => {
        replace({
          pathname: '/'
        })
        cb()
      })
  }
}

function roleBaseNavigation(route, replace, cb, state) {
  const { pathname } = route.location
  const { isSalesRoleOnly, isRcmAdmin, userInfo } = state
  const { roles = [] } = userInfo || {}
  const isRcmPaymentTransfer = roles.includes('RCM_PAYMENT_TRANSFER')

  const isUnauthorisedAccessPath = pathname === '/unauthorised-access'
  const shouldRedirectToUnauthorised =
    (isSalesRoleOnly && !pathname.startsWith('/detail/')) ||
    (!isRcmAdmin && pathname === '/invoice-month') ||
    (!isRcmPaymentTransfer && pathname === '/transfer-wallet')

  const shouldRedirectToHome = !isSalesRoleOnly && isUnauthorisedAccessPath

  if (shouldRedirectToUnauthorised && !isUnauthorisedAccessPath) {
    replace({ pathname: '/unauthorised-access' })
  } else if (shouldRedirectToHome) {
    replace({ pathname: '/' })
  }
  cb()
}



/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/